import { useLocation } from "react-router-dom";
import React, { useEffect, useRef } from "react";
import { v4 as uuid } from "uuid";
import { LinearProgress } from "@material-ui/core";

import { getOAuth2CodeUrl } from "../../api/OAuth2Client";
import { useConfigContext } from "../../features/Auth";
import { useAuthSessionContext } from "../../features/Auth/AuthSessionProvider";

export const LoginView = () => {
  const { state, pathname } = useLocation<{ from?: string }>();
  const { authConfig } = useConfigContext();
  const { startSession } = useAuthSessionContext();

  const isUnmounting = useRef(false);

  const from = state?.from && state.from !== pathname ? state.from : "/";
  // Always trigger oauth flow from the login page
  useEffect(() => {
    if (!isUnmounting.current && authConfig) {
      isUnmounting.current = true;
      const newSession = {
        sessionId: uuid(),
        sessionInitialPath: from,
      };
      startSession(newSession);
      // use window.location to redirect to an external URL
      window.location.replace(getOAuth2CodeUrl(newSession, authConfig));
    }
  }, [from, authConfig, startSession]);

  return <LinearProgress />;
};
